import type * as Types from '@__graphql__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckoutSuccessQueryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CheckoutSuccessQueryQuery = { user?: { id?: string | null, language?: any | null, hash?: string | null } | null, magento2?: { customer?: { nativeId?: string | null, firstname?: string | null, email?: string | null } | null, cmsBlocks?: { items?: Array<{ title?: string | null, identifier?: string | null, content?: string | null } | null> | null } | null } | null };

export type CheckoutOrderQueryQueryVariables = Types.Exact<{
  orderNumber?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CheckoutOrderQueryQuery = { magento2?: { storeConfig?: { storeCode?: string | null, taxSalesDisplayPrice?: string | null, taxSalesDisplaySubtotal?: string | null } | null, customer?: { nativeId?: string | null, globalOrders?: { items: Array<{ number: string, id: string, isVirtual?: boolean | null, carrier?: string | null, storeCode?: string | null, shippingMethod?: string | null, billingAddress?: { city: string, region?: string | null, countryCode?: Types.Magento2_CountryCodeEnum | null } | null, paymentMethods?: Array<{ name: string } | null> | null, items?: Array<{ productName?: string | null, productSku: string, quantityOrdered?: number | null, productImage?: string | null, productSerialSystem?: string | null, id: string, productType?: string | null, productSalePrice: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, productSalePriceIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, discounts?: Array<{ label: string, amount: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | null> | null } | { productName?: string | null, productSku: string, quantityOrdered?: number | null, productImage?: string | null, productSerialSystem?: string | null, id: string, productType?: string | null, productSalePrice: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, productSalePriceIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, discounts?: Array<{ label: string, amount: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | null> | null } | { productName?: string | null, productSku: string, quantityOrdered?: number | null, productImage?: string | null, productSerialSystem?: string | null, id: string, productType?: string | null, productSalePrice: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, productSalePriceIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, discounts?: Array<{ label: string, amount: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | null> | null } | { productName?: string | null, productSku: string, quantityOrdered?: number | null, productImage?: string | null, productSerialSystem?: string | null, id: string, productType?: string | null, productSalePrice: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, productSalePriceIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, discounts?: Array<{ label: string, amount: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | null> | null } | null> | null, total?: { discounts?: Array<{ label: string, amount: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | null> | null, totalGiftcard?: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } | null, totalShipping: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null }, shippingHandling?: { amountExcludingTax?: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } | null, amountIncludingTax?: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } | null } | null, grandTotal: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, taxes?: Array<{ title: string, amount: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | null> | null, totalTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, subtotal: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, subtotalIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | null } | null> } | null } | null } | null };

export type UserV2QueryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserV2QueryQuery = { userV2?: { ecommerce_status: Types.EcommerceStatus } | {} | null };


export const CheckoutSuccessQueryDocument = gql`
    query CheckoutSuccessQuery {
  user {
    id
    language
    hash
  }
  magento2 {
    customer {
      nativeId
      firstname
      email
    }
    cmsBlocks(
      identifiers: ["success-hardware-notice", "success-general-notice", "success-software-notice"]
    ) {
      items {
        title
        identifier
        content
      }
    }
  }
}
    `;

/**
 * __useCheckoutSuccessQueryQuery__
 *
 * To run a query within a React component, call `useCheckoutSuccessQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutSuccessQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutSuccessQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckoutSuccessQueryQuery(baseOptions?: Apollo.QueryHookOptions<CheckoutSuccessQueryQuery, CheckoutSuccessQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutSuccessQueryQuery, CheckoutSuccessQueryQueryVariables>(CheckoutSuccessQueryDocument, options);
      }
export function useCheckoutSuccessQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutSuccessQueryQuery, CheckoutSuccessQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutSuccessQueryQuery, CheckoutSuccessQueryQueryVariables>(CheckoutSuccessQueryDocument, options);
        }
export type CheckoutSuccessQueryQueryHookResult = ReturnType<typeof useCheckoutSuccessQueryQuery>;
export type CheckoutSuccessQueryLazyQueryHookResult = ReturnType<typeof useCheckoutSuccessQueryLazyQuery>;
export type CheckoutSuccessQueryQueryResult = Apollo.QueryResult<CheckoutSuccessQueryQuery, CheckoutSuccessQueryQueryVariables>;
export const CheckoutOrderQueryDocument = gql`
    query CheckoutOrderQuery($orderNumber: String) {
  magento2 {
    storeConfig {
      storeCode
      taxSalesDisplayPrice
      taxSalesDisplaySubtotal
    }
    customer {
      nativeId
      globalOrders(filter: {number: {eq: $orderNumber}}, pageSize: 1) {
        items {
          number
          id
          isVirtual
          carrier
          storeCode
          shippingMethod
          billingAddress {
            city
            region
            countryCode
          }
          paymentMethods {
            name
          }
          items {
            productName
            productSku
            quantityOrdered
            productImage
            productSerialSystem
            id
            productSalePrice {
              currency
              value
            }
            productSalePriceIncludingTax {
              currency
              value
            }
            productType
            discounts {
              amount {
                currency
                value
              }
              label
            }
          }
          total {
            discounts {
              label
              amount {
                currency
                value
              }
            }
            totalGiftcard {
              currency
              value
            }
            totalShipping {
              value
              currency
            }
            shippingHandling {
              amountExcludingTax {
                value
                currency
              }
              amountIncludingTax {
                value
                currency
              }
            }
            grandTotal {
              currency
              value
            }
            taxes {
              title
              amount {
                currency
                value
              }
            }
            totalTax {
              currency
              value
            }
            subtotal {
              currency
              value
            }
            subtotalIncludingTax {
              currency
              value
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCheckoutOrderQueryQuery__
 *
 * To run a query within a React component, call `useCheckoutOrderQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutOrderQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutOrderQueryQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useCheckoutOrderQueryQuery(baseOptions?: Apollo.QueryHookOptions<CheckoutOrderQueryQuery, CheckoutOrderQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutOrderQueryQuery, CheckoutOrderQueryQueryVariables>(CheckoutOrderQueryDocument, options);
      }
export function useCheckoutOrderQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutOrderQueryQuery, CheckoutOrderQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutOrderQueryQuery, CheckoutOrderQueryQueryVariables>(CheckoutOrderQueryDocument, options);
        }
export type CheckoutOrderQueryQueryHookResult = ReturnType<typeof useCheckoutOrderQueryQuery>;
export type CheckoutOrderQueryLazyQueryHookResult = ReturnType<typeof useCheckoutOrderQueryLazyQuery>;
export type CheckoutOrderQueryQueryResult = Apollo.QueryResult<CheckoutOrderQueryQuery, CheckoutOrderQueryQueryVariables>;
export const UserV2QueryDocument = gql`
    query UserV2Query {
  userV2 {
    ... on AuthenticatedUser {
      ecommerce_status
    }
  }
}
    `;

/**
 * __useUserV2QueryQuery__
 *
 * To run a query within a React component, call `useUserV2QueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserV2QueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserV2QueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserV2QueryQuery(baseOptions?: Apollo.QueryHookOptions<UserV2QueryQuery, UserV2QueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserV2QueryQuery, UserV2QueryQueryVariables>(UserV2QueryDocument, options);
      }
export function useUserV2QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserV2QueryQuery, UserV2QueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserV2QueryQuery, UserV2QueryQueryVariables>(UserV2QueryDocument, options);
        }
export type UserV2QueryQueryHookResult = ReturnType<typeof useUserV2QueryQuery>;
export type UserV2QueryLazyQueryHookResult = ReturnType<typeof useUserV2QueryLazyQuery>;
export type UserV2QueryQueryResult = Apollo.QueryResult<UserV2QueryQuery, UserV2QueryQueryVariables>;